/**
 * Created by Ning Jiang on 2021-12-20.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {TombstoneRip} from "../../TombstoneRip";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TombstoneRipGameMode} from "../../gameflow/TombstoneRipGameMode";
import {Layers, TombstoneRipLayers} from "../../view/TombstoneRipLayers";
import {TombstoneRipReelView} from "../../reels/TombstoneRipReelView";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";

export class ReelNearWinController extends ReelStopPresentationController {

    private _defaultNearWinSpinStepDuration:number = 0.02;

    private _glow:TimelineSprite;
    private _nearWinReel:number = -1;
    private _nearWinSound:string = "";

    constructor() {
        super('ReelNearWinController');
    }

    // TODO: in other games if there is inactive reel then near win in next reel, need to handle it.
    protected onReelStopped(data:IReelStateEventData):Promise<any> {
        const reel = TombstoneRip.reels[data.reelId];
        if(!reel.isQuickStop && reel.nextStopReel != null && TombstoneRip.reels[reel.nextStopReel].reelState === ReelState.SPIN && TombstoneRip.reels[reel.nextStopReel].hasNearWin()) {
            this.setReelNearWinSpin(reel.nextStopReel);
            if(TombstoneRip.model.parsedGameData.nearWinBigWinReels[reel.nextStopReel]) {
                this.playNearWin(reel.nextStopReel);
                return super.onReelStopped(data);
            }
        }

        if(data.reelId === this._nearWinReel) {
            this._nearWinReel = -1;
            this.stopNearWin();
        }

        return super.onReelStopped(data);
    }

    private setReelNearWinSpin(reelId:number):void {
        if(TombstoneRip.reels[reelId].reelView.nextSpinStepConfig) {
            TombstoneRip.reels[reelId].reelView.nextSpinStepConfig!.duration = this._defaultNearWinSpinStepDuration;
        } else {
            TombstoneRip.reels[reelId].reelView.nextSpinStepConfig = {
                duration : this._defaultNearWinSpinStepDuration,
            }
        }
    }

    private playNearWin(reelId:number):void {
        this._nearWinReel = reelId;
        if(!this._glow) {
            this._glow = new TimelineSprite(TombstoneRip.assetLoader.getTextures("nearwin/glow/bNearWn_"));
            this._glow.anchor.set(0.5, 0.5);
            this._glow.scale.x = 0.77;
            this._glow.hide();
            this._glow.blendMode = PIXI.BLEND_MODES.ADD;
            TombstoneRipLayers.getLayer(Layers.NEAR_WIN)!.addChild(this._glow);
        }
        const positionX = TombstoneRipReelView.REEL_AREAS[reelId].x;
        const positionY = TombstoneRipReelView.REEL_AREAS[reelId].y + TombstoneRipReelView.REEL_AREAS[reelId].height * 0.5 - 20;
        this._glow.position.set(positionX, positionY);
        this._glow.scale.y = reelId === 4 ? 4.6 : 7.2;
        this._glow.alpha = TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER ? 0.8 : 0.5;
        // this._glow.tint = this.getTintColor();
        this._glow.playLoop();
        this._glow.show();
        this._nearWinSound = TombstoneRip.model.parsedGameData.mode === TombstoneRipGameMode.FREESPIN_SUPER ? TombstoneRipSound.BIG_WIN_NEAR_WIN_SUPER : TombstoneRipSound.BIG_WIN_NEAR_WIN;
        TombstoneRipSound.soundPlayer.playTrack({name : this._nearWinSound, volume : 1});
    }

    private getTintColor():number {
        switch(TombstoneRip.model.parsedGameData.mode) {
            case GameMode.NORMAL:
                return 0xD08713;
            case GameMode.FREESPIN:
                return 0xD08713;
            case TombstoneRipGameMode.FREESPIN_SUPER:
                return 0xFFFFFF;
            default:
                return 0xFFFFFF;
        }
    }

    private stopNearWin():void {
        if(this._glow) {
            this._glow.hide();
            this._glow.stopLoop();
        }
        if(this._nearWinSound.length > 0) {
            TombstoneRipSound.fadeAndStopSound({
                name : this._nearWinSound,
                to : 0,
                duration : 100
            });
            this._nearWinSound = "";
        }
    }

    public playSFSReel5NearWin():void {
        this.setReelNearWinSpin(4);
        this.playNearWin(4);
    }
}